import React from 'react';
import { ThermometerSnowflake, Waves, Droplets, Fuel, Droplet, Gauge, Filter, FlaskConical, Sprout, ArrowDownToLine } from 'lucide-react';
const pumpTypes = [{
  name: 'Marine Engine Cooling Pumps',
  icon: ThermometerSnowflake
}, {
  name: 'Bilge Pumps',
  icon: Waves
}, {
  name: 'Freshwater & RV Water Pumps',
  icon: Droplets
}, {
  name: 'Fuel Transfer Pumps',
  icon: Fuel
}, {
  name: 'Oil Transfer Pumps',
  icon: Droplet
}, {
  name: 'High-Pressure Water Pumps',
  icon: Gauge
}, {
  name: 'Reverse Osmosis & Desalination Pumps',
  icon: Filter
}, {
  name: 'Chemical & Industrial Transfer Pumps',
  icon: FlaskConical
}, {
  name: 'Agricultural Irrigation Pumps',
  icon: Sprout
}, {
  name: 'Well & Sump Pumps',
  icon: ArrowDownToLine
}];
export function PumpTypes() {
  return <section className="w-full bg-white" data-id="element-99">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-100">
        <div className="mb-6" data-id="element-101">
          <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-2" data-id="element-102">
            Common Pump Types
          </h2>
          <p className="text-slate-600" data-id="element-103">
            Browse by the type of pump that matches your application.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3" data-id="element-104">
          {pumpTypes.map(type => <div key={type.name} className="group flex flex-col items-start gap-3 bg-white p-4 rounded-lg border border-slate-200 hover:border-marine-blue hover:shadow-sm transition-all duration-150" data-id="element-105">
              <div className="bg-marine-light text-marine-blue p-2 rounded-md group-hover:bg-marine-blue group-hover:text-white transition-colors duration-150" data-id="element-106">
                <type.icon className="w-5 h-5" data-id="element-107" />
              </div>
              <h3 className="text-sm font-semibold text-slate-800 leading-snug" data-id="element-108">
                {type.name}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}